var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"flowPreviewContainer",staticClass:"flowContainerWithXml",style:({height: _vm.height+'px'})},[_c('div',{ref:"canvas",staticClass:"canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }